import React from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { bool, func, object, string } from 'prop-types';
import FieldTextInput from '../../../../components/FieldTextInput/FieldTextInput';
import css from './EditListingPricingForm.module.css';
import { FieldCurrencyInput } from '../../../../components';

const CustomFieldArray = props => {
  const {
    push,
    pop,
    removeButtonText,
    addButtonText,
    arrayName,
    optionFieldLabel,
    optionFieldPlaceHolder,
    priceFieldLabel,
    priceFieldPlaceHolder,
    currencyConfig,
    isOptions,
    descriptionValidators,
    formValues,
  } = props;

  const priceValidators = !isOptions ? props.priceValidators : null;

  return (
    <div>
      <FieldArray name={arrayName}>
        {({ fields }) =>
          fields.map((name, index) => (
            <div key={name} className={css.itemContainer}>
              <FieldTextInput
                className={css.optionInput}
                type="text"
                id={`${name}.description`}
                name={`${name}.description`}
                label={optionFieldLabel}
                placeholder={optionFieldPlaceHolder}
                validate={descriptionValidators}
              />

              <FieldCurrencyInput
                id={`${name}.price`}
                name={`${name}.price`}
                className={css.input}
                label={priceFieldLabel}
                placeholder={priceFieldPlaceHolder}
                currencyConfig={currencyConfig}
                validate={priceValidators}
              />

              {/*<button type="button" className={css.removeOption} onClick={() => fields.remove(index)}>*/}
              {/*  {removeButtonText}*/}
              {/*</button>*/}
            </div>
          ))
        }
      </FieldArray>

      <div className={css.buttons}>
        <button type="button" onClick={() => push(arrayName, undefined)} className={css.addOption}>
          {addButtonText}
        </button>
        {formValues?.additionalLocations && formValues?.additionalLocations?.length > 0 && (
          <button type="button" onClick={() => pop(arrayName)} className={css.removeOption}>
            {removeButtonText}
          </button>
        )}
      </div>
    </div>
  );
};

CustomFieldArray.propTypes = {
  rootClassName: string,
  className: string,
  inputRootClass: string,

  onUnmount: func,

  // Error message that can be manually passed to input field,
  // overrides default validation message
  customErrorText: string,

  // Label is optional, but if it is given, an id is also required so
  // the label can reference the input in the `for` attribute
  id: string,
  label: string,

  // Uncontrolled input uses defaultValue prop, but doesn't pass value from form to the field.
  // https://reactjs.org/docs/uncontrolled-components.html#default-values
  isUncontrolled: bool,
  // a ref object passed for input element.
  inputRef: object,
};

export default CustomFieldArray;
